<template>
  <div>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="loading">登录</el-button>
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
    <el-divider>第三方用户登录</el-divider>
    <a href="https://oapi.dingtalk.com/connect/qrconnect?appid=dingoacozmr7jvdxsrs1se&response_type=code&scope=snsapi_login&state=1&redirect_uri=http://www.test2.com:8090/api/DingTalk/ThirdPartyLogin"><img :src="require('../assets/dingtalklogo.jpg')" width="72px" height="72px" /></a>
  </el-form>
  </div>
</template>

<script>
import ImagePaste from '@/components/ImagePaste.vue'

export default {
  components: { ImagePaste },
  name: 'login',
  data () {
    return {
      imgs: [],
      loading: false,
      ruleForm2: {
        account: 'admin',
        checkPass: '123456'
      },
      rules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  methods: {
    handleReset2 () {
      this.$refs.ruleForm2.resetFields()
    },
    handleSubmit2 (ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          // _this.$router.replace('/table');
          // NProgress.start();
          var loginParams = { usercode: this.ruleForm2.account, password: this.ruleForm2.checkPass }
          this.$ajax({
            url: 'api/Account/Login',
            loadingName: 'loading',
            data: JSON.stringify(loginParams),
            success: (d) => {
              sessionStorage.setItem('user', JSON.stringify(d))
              this.$router.push({ path: '/home' })
            }
          })
        } else {
          console.log('error sufbmit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }    
  }
  .image-block {
      padding: 30px 0;
      text-align: center;
      border-right: 1px solid #eff2f6;
      display: inline-block;
      width: 20%;
      box-sizing: border-box;
      vertical-align: top;
    }
</style>
